import {
  faArrowRight,
  faClipboardCheck,
  faCubes,
  faPeopleArrows,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import projectsHero from "../Assets/heroes/projects-hero.webp";
import CallToAction from "../Components/CallToAction";
import PrimaryHero from "../Components/PrimaryHero";
import SectionHeading from "../Components/SectionHeading";

const projectOutcomes = [
  {
    icon: faClipboardCheck,
    label: "Workflow",
    title: "Turn manual steps into clear systems",
    copy: "We shape repeatable tasks into software that is easier to track, share, and improve.",
  },
  {
    icon: faPeopleArrows,
    label: "Service access",
    title: "Help people reach services faster",
    copy: "We build web and mobile flows that make information, requests, and support easier to access.",
  },
  {
    icon: faRocket,
    label: "Product launch",
    title: "Move focused ideas into usable products",
    copy: "We help teams start with a practical first version, then improve it with real feedback.",
  },
];

function Projects() {
  return (
    <div className="primary-page">
      <PrimaryHero
        titleId="projects-title"
        icon={faCubes}
        kicker="Projects"
        title="Project work focused on useful outcomes."
        description={
          <p>
              MileSoft projects begin with one question: what needs to become
              simpler for the people using it? From there, we shape a clear
              build that supports the outcome.
          </p>
        }
        imageSrc={projectsHero}
        actions={
          <>
              <Link to="/contacts" className="btn-ms btn-ms-primary btn-ms-lg">
                Plan a project
                <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
              </Link>
              <Link
                to="/portfolio"
                className="btn-ms btn-ms-secondary btn-ms-lg"
              >
                See examples
              </Link>
          </>
        }
      />

      <section
        className="section-ms section-ms-soft"
        aria-labelledby="project-outcomes-title"
      >
        <div className="section-ms-inner">
          <SectionHeading
            titleId="project-outcomes-title"
            kicker="Common outcomes"
            title="What a MileSoft project can improve"
            description={
              <p>
              The details change from client to client, but the goal stays the
              same: make a real task simpler, clearer, and more reliable.
              </p>
            }
          />
          <div className="primary-card-grid primary-card-grid-three">
            {projectOutcomes.map((project) => (
              <article
                className="card-ms primary-info-card"
                key={project.title}
              >
                <div className="card-ms-body">
                  <div className="primary-card-meta">
                    <span className="brand-icon" aria-hidden="true">
                      <FontAwesomeIcon icon={project.icon} />
                    </span>
                    <span className="badge-ms">{project.label}</span>
                  </div>
                  <h3>{project.title}</h3>
                  <p>{project.copy}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CallToAction
        titleId="project-next-title"
        kicker="Next step"
        title="Start with the problem you need solved."
        description={
          <p>
              You do not need a full technical brief to begin. Tell us the
              workflow, product idea, or service gap, and we will help define a
              simple first step.
          </p>
        }
        action={
          <Link to="/contacts" className="btn-ms btn-ms-primary btn-ms-md">
            Contact MileSoft
          </Link>
        }
      />
    </div>
  );
}

export default Projects;
